// export const scrollToTargetAdjusted = (elementId, offset = 100) => {
//   if (typeof document === "undefined") return;
//   const el = document.getElementById(elementId);
//   if (!el) return;
//   const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
//   window.scrollTo({ top: y, behavior: "smooth" });
// };

// export const scrollToTargetAdjusted = (targetId) => {
//     const config = getConfig();
//     const element = document.getElementById(targetId);
//     // console.log('element', element);
//     if (!element) return;
//     const elementPosition = element.getBoundingClientRect().top;
//     const offsetPosition =
//         elementPosition - config?.scrollToTargetAdjustedValue || 80; //set this dynamically
//     // console.log(elementPosition, offsetPosition, config?.scrollToTargetAdjustedValue, 'xyz');
//     window.scrollBy({
//         top: offsetPosition,
//         behavior: 'smooth'
//     });
// };
export var scrollToTargetAdjusted = function scrollToTargetAdjusted(targetId, config) {
  // 1. Get configuration and target element
  var element = document.getElementById(targetId);
  if (!element) return; // Exit if element not found

  // 2. Calculate scroll position
  var headerOffset = (config === null || config === void 0 ? void 0 : config.scrollToTargetAdjustedValue) || 80; // Default to 80px if not in config
  var elementPosition = element.getBoundingClientRect().top; // Distance from viewport top
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  // 3. Check for smooth scroll support
  if ("scrollBehavior" in document.documentElement.style) {
    // 4. Smooth scrolling (modern browsers)
    window.scrollTo({
      top: offsetPosition,
      // Scroll to this exact position
      behavior: "smooth" // Animate the scroll
    });
  } else {
    // 5. Instant scroll (older browsers)
    window.scrollTo(0, offsetPosition); // x=0, y=offsetPosition
  }
};
export var isInWebView = function isInWebView() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;

  // iOS WebView: iPhone/iPad but not Safari
  var iOSWebView = /iPhone|iPod|iPad/i.test(ua) && !/Safari/i.test(ua);

  // Android WebView: Android with "wv" in UA
  var androidWebView = /Android/i.test(ua) && /\bwv\b/.test(ua);
  return iOSWebView || androidWebView;
};